const ACTIVITY_GETTERS = {
  getUserActivityList: (state) => state.userActivities,
  getUserActivityFilter: (state) => state.userActivityFilter,
  getActivity: (state) => state.userActivity,
  getLoadingState: (state) => state.status.loading,
  getButtonLoadingState: (state) => state.buttonLoading,
};

export default ACTIVITY_GETTERS;
